import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { HttpClient } from '@angular/common/http';
import { provinceUrl, cityUrl, barangayUrl, countryUrl, vatUrl, supplierUrl, miscellaneousUrl } from '../../common/api';

@Injectable()
export class AddressService extends HttpService {

  constructor(http: HttpClient) { 
    super('',http);
  }

  getProvince(){
    return this.http.get(provinceUrl).map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getCountry(){
    return this.http.get(countryUrl).map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getCity(id){
    return this.http.get(cityUrl + '/' + id).map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getCityList(name  = ''){
    return this.http.get(cityUrl + '?title=' + name).map((dataResponse) => {
      return dataResponse['data'];
    });
  }


  getBarangay(id){
    return this.http.get(barangayUrl + '/' + id).map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getVat(){
    return this.http.get(vatUrl + '/').map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getSupplier(){
    return this.http.get(supplierUrl + '/').map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  getMisc(){
    return this.http.get(miscellaneousUrl + '/').map((dataResponse) => {
      return dataResponse['data'];
    });
  }

}